import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { map, toArray } from 'lodash'
import { ui } from '../redux'

import Toast from '../components/Toast'

const ToastsList = ({ items, dispatch }) => (
    <div id="gritter-notice-wrapper" className="gritter-main-wrapper top-right">
        { map(items, ({ id, message, ...otherProps }) => (
            <Toast
                key={ id }
                onClose={ () => dispatch(ui.closeToast(id)) }
                message={ message }
                { ...otherProps }
            />
        ))}
    </div>
)

ToastsList.propTypes = {
    dispatch : PropTypes.func.isRequired,
    items    : PropTypes.arrayOf(PropTypes.object)
}

function mapStateToProps(state) {
    return {
        items: toArray(ui.getToasts(state))
    }
}

export default connect(mapStateToProps)(ToastsList)
